<template>
    <div>
       <DescribeShippment/>
    </div>
</template>

<script>
import DescribeShippment from "@/components/Ondemand/Bookings/DescribeShippment.vue";
    export default {
        components:{
            DescribeShippment
        }
    }
</script>

<style lang="scss" scoped>

</style>